import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  TextField,
  Typography,
  Paper,
  Button,
  Stepper,
  Step,
  StepLabel,
  Grid2,
  Stack,
  Divider,
  Tooltip,
  Avatar, IconButton, Modal, Checkbox, List, ListItem, ListItemText, ListItemIcon,
  Dialog, DialogTitle, DialogContent, DialogActions,
  CircularProgress
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { useParams } from 'react-router-dom'
import { getSingleProject, approveProject, updateProjectTopic, addUserToProject, uploadProjectScriptFile, generateHeygenVideos, getProjectVideoVersionStatusById, getProjectVideoVersionStatusByProject } from "../apis/apiList/projectApi";
import { getProductionTeam, getUsersByOrgId } from "../apis/apiList/userApi";
import api from '../apis/api';
import { useMessage } from "../context/MessageContext";
import { useApp } from "../context/AppContext";
import { SAMPLE_AVATARS, getAvatarImageUrl } from "../utils/avatars";
import CreateVoiceOverStage from "../components/ProjectStage/CreateVoiceOverStage";
import CreateVideoStage from "../components/ProjectStage/CreateVideoStage";
import NewsletterScriptModal from "../components/ProjectStage/NewsletterScriptModal";
import BeatLoader from "react-spinners/BeatLoader";
import theme from "../theme/theme";
import { ProjectChat } from "../components/ProjectStage/ProjectChat";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ScriptPdf from "../components/ProjectStage/ScriptPdf";
import ApproveStageModal from "../components/ProjectStage/ApproveStageModal";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import ProjectInfo from "../components/ProjectStage/ProjectInfo";
// import FullAutomatedBoard from "../components/ProjectStage/FullAutomatedBoard";
import { getOrganizationTemplateById } from '../apis/apiList/templateApi';
import VisualFileUploadModal from "../components/ProjectStage/VisualFileUploadModal";
import VisualPreviewModal from "../components/ProjectStage/VisualPreviewModal";
import SceneImageUploadModal from "../components/ProjectStage/SceneImageUploadModal";
import { getSceneImagesByProjectIdAndTopicId } from "../apis/apiList/projectApi";
import AvatarSelectionModal from "../components/ProjectStage/AvatarSelectionModal";

const steps = ["Scripts & Visuals", "Voice Over", "Video"];
const automatedSteps = ["Scripts", "Video"];

const override = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
};


const CustomStepIcon = (props) => {
  const { active, completed, icon, approved } = props;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 26,
        height: 26,
        borderRadius: "50%",
        backgroundColor: active ? "#D10000" : completed || approved ? "#D10000" : "#D10000",
        color: "white",
        // fontWeight: "bold",
        fontSize: "0.75rem",
      }}
    >
      {/* {approved || completed ? <CheckIcon style={{ fontSize: 20 }} /> : icon} */}
      {approved || completed ? <CheckIcon style={{ fontSize: 20 }} /> : icon}
    </div>
  );
};

const ProjectBoard = () => {
  const topicsData =  [
    { title: "Opening", content: "", wordCount: 0 },
    { title: "Topic 5", content: "", wordCount: 0 },
    { title: "Topic 4", content: "", wordCount: 0 },
    { title: "Topic 3", content: "", wordCount: 0 },
    { title: "Topic 2", content: "", wordCount: 0 },
    { title: "Topic 1", content: "", wordCount: 0 },
    { title: "Closing", content: "", wordCount: 0 },
  ];
  const topicsData2 = [
    { title: "Opening", content: "", wordCount: 0 },
    { title: "Topic five", content: "", wordCount: 0 },
    { title: "Topic four", content: "", wordCount: 0 },
    { title: "Topic three", content: "", wordCount: 0 },
    { title: "Topic two", content: "", wordCount: 0 },
    { title: "Topic one", content: "", wordCount: 0 },
    { title: "Closing", content: "", wordCount: 0 },
  ];
  const [approvedSteps, setApprovedSteps] = React.useState([false, false, false]);
  const [sharedAvatars, setSharedAvatars] = useState(SAMPLE_AVATARS);
  const [projectAvatar, setProjectAvatar] = useState(null);
  const [topics, setTopics] = useState(topicsData);
  const [project, setProject] = useState({});
  const [originalProject, setOriginalProject] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [totalWordCount, setTotalWordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { projectId, id } = useParams();
  const {showMessage} = useMessage();
  const {userDetails} = useApp();
  const [productionTeam, setProductionTeam] = useState([]);
  const [orgCustomer, setOrgCustomer] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [displayedUsers, setDisplayedUsers] = useState([]);
  const [allUsersForDisplay, setAllUsersForDisplay] = useState([]);
  const [extraCount, setExtraCount] = useState(0);
  const [currentUser, setCurrentUser] = useState({});
  const [associatedUser, setAssociatedUser] = useState([]);
  const [tempSelectedUser, setTempSelectedUser] = useState([]);
  const [isUpdatingLoader, setIsUpdatingLoader] = useState(false);
  const [forOneTimeRender, setForOneTimeRender] = useState(true);
  const [isScriptApproving, setIsScriptApproving] = useState(false);
  const [isStageApproving, setIsStageApproving] = useState(false);
  const pdfRef = useRef(null);
  useEffect(() => {
    // derive avatar for project when project or shared avatars change
    const findAvatarForProject = async () => {
      if (!project) return setProjectAvatar(null);
      const maybe = project?.avatar_id || project?.avatarId || project?.selectedAvatar?.avatar_id || project?.selectedAvatar?.id || project?.heygenTemplate?.avatar_id || project?.heygenTemplate?.character_id || project?.orgAvatarId || project?.avatar || project?.avatarId;
      console.log('Project avatar matching - maybe:', maybe, 'project:', project);
      if (!maybe) return setProjectAvatar(null);
      const idStr = String(maybe);
      let found = sharedAvatars.find(a => String(a.avatar_id || a.id || a._id || a.character_id) === idStr);
      console.log('Found avatar (local):', found);

      if (!found) {
        // Try backend API to fetch merged HeyGen + local avatar details
        try {
          const resp = await api.get(`/heygen/avatars/${encodeURIComponent(idStr)}`, {
            headers: { 'x-access-token': userDetails?.jwtToken || '' }
          });
          console.log('Fetched avatar details from backend for', resp?.data);

          const merged = resp?.data?.data || resp?.data || null;
          const heygenData = resp?.data?.heygen?.data || null;
          if (merged) {
            // Normalize into sample avatar shape for UI
            found = {
              avatar_id: idStr,
              avatar_name: heygenData?.name || (merged.local && (merged.local.avatar_name || merged.local.name)) || (merged.heygen && (merged.heygen.name || merged.heygen.title)) || 'Avatar',
              gender: (merged.local && merged.local.gender) || (merged.heygen && (merged.heygen.gender || merged.heygen.sex)) || '',
              preview_image_url: heygenData?.preview_image_url || (merged.local && (merged.local.preview_image_url || merged.local.image_url)) || (merged.heygen && (merged.heygen.preview_image_url || merged.heygen.image_url)) || null,
              group_id: (merged.local && merged.local.group_id) || merged.group_id || null,
              template_id: (merged.local && merged.local.template_id) || merged.template_id || null,
            };
            console.log('Found avatar (remote):', found);
          }
        } catch (e) {
          console.warn('Failed to fetch avatar details for', idStr, e?.response?.data || e.message || e);
        }
      }

      setProjectAvatar(found || null);
    };
    findAvatarForProject();
  }, [project, sharedAvatars]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [approveStageName, setApproveStageName] = useState('');
  const [approvedVoiceOverFileId, setApprovedVoiceOverFileId] = useState('');
  const [approvedVideoFileId, setApprovedVideoFileId] = useState('');
  const [approvedVerticalVideoFileId, setApprovedVerticalVideoFileId] = useState('');
  const [orgDetailsWithTemplate, setOrgDetailsWithTemplate] = useState({});
  const [isChangedScript, setIsChangedScript] = useState(false);
  const [confirmModalScript, setConfirmModalScript] = useState(false);
  const [updatingScript, setUpdatingScript] = useState(false);
  const [disableScriptPopUpBtn, setDisableScriptPopUpBtn] = useState(false);
  const navigate = useNavigate();
  const [openEditor, setOpenEditor] = useState({ index: null, type: null });
  const [openVisualFileUploader, setOpenVisualFileUploader] = useState(false);
  const [openVisualPreview, setOpenVisualPreview] = useState(false);
  const [selectedVisualUploaderId, setSelectedVisualUploaderId] = useState(null);
  const [selectedVisualPreviewId, setSelectedVisualPreviewId] = useState(null);
  const inputRef = useRef();
  const [openSceneUploader, setOpenSceneUploader] = useState(false);
  const [selectedSceneUploaderId, setSelectedSceneUploaderId] = useState(null);
  const [sceneImagesMap, setSceneImagesMap] = useState({});
  const [avatarModalOpen, setAvatarModalOpen] = useState(false);
  const [scriptGenerateModalOpen, setScriptGenerateModalOpen] = useState(false);
  const [heygenTemplateDetails, setHeygenTemplateDetails] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedVersionId, setGeneratedVersionId] = useState(null);
  const [versionStatus, setVersionStatus] = useState('');
  // no polling; we'll perform a one-time status check on load
  const [confirmGenerateModalOpen, setConfirmGenerateModalOpen] = useState(false);

  useEffect(() => {
    if (openEditor.index !== null && inputRef.current) {
      inputRef.current.focus();
    }
  }, [openEditor]);

  const handleToggle = (id, user) => {
    setSelectedUsers((prev) => 
      prev.includes(id) ? prev.filter((userId) => userId !==id) : [...prev, id]
    );

    setTempSelectedUser((prev) => {
      const exists = prev.find((u) => u._id === user._id);
  
      if (exists) {
        // If user already exists in temp, remove them
        return prev.filter((u) => u._id !== user._id);
      } else {
        // If not, find the user in productionTeam or orgCustomer
        const fromProduction = productionTeam.find((u) => u._id === user._id);
        const fromCustomer = orgCustomer.find((u) => u._id === user._id);
        const foundUser = fromProduction || fromCustomer;
  
        if (foundUser) {
          // Add found user to temp
          return [...prev, foundUser];
        } else {
          // If user not found in either, do nothing
          return prev;
        }
      }
    });
    
  };

  useEffect(()=>{

    async function fetchProject() {
      
      let addedUserInProject=[];
      try {
        if(projectId) {
          const project = await getSingleProject(projectId);
          console.log('project', project)

          if(project?.data?.heygenTemplate?.data) {
            setHeygenTemplateDetails(project.data.heygenTemplate.data);
          }
          // Check if user is part of associatedUsers
          const isUserAssociated = project?.data?.associatedUsers.some(
            (user) => user._id === userDetails._id
          );

          if (!isUserAssociated) {
            // User is not authorized to view the project
            if(userDetails.role == 'subscriber') {
              showMessage('You are not added to this project.', 'error');
              navigate(`/subs/org/${userDetails.orgId}/projects`);
            } else {
              showMessage('You are not authorized to view this project', 'error');
              navigate(`/org/${project?.data?.orgId?._id}/projects`);
            }
            return;
          }

          // console.log('project?.data?.associatedUsers.slice(0, 3)', project?.data?.associatedUsers.slice(0, 3))
          // console.log('project?.data?.associatedUsers.slice(0, 3)', project?.data?.associatedUsers.length > 3 ? project?.data?.associatedUsers.length - 3 : project?.data?.associatedUsers.length)
          setApprovedVideoFileId(project?.data?.vimeoVideoId || '');
          setApprovedVerticalVideoFileId(project?.data?.vimeoVerticalVideoId || '');
          setApprovedVoiceOverFileId(project?.data?.approvedVoiceOverFileId || '');

          let associatedUsers = project?.data?.associatedUsers || [];
          
          console.log('associatedUsers facepile before', associatedUsers)

          associatedUsers = associatedUsers.reduce((uniqueUsers, user) => {
            if (!uniqueUsers.some(existingUser => existingUser._id === user._id)) {
              uniqueUsers.push(user);
            }
            return uniqueUsers;
          }, []);

          console.log('associatedUsers facepile', associatedUsers)
          setDisplayedUsers(associatedUsers.slice(0, 3));
          setAllUsersForDisplay(associatedUsers);
          setExtraCount(associatedUsers.length > 3 ? associatedUsers.length - 3 : 0);
          
          if(associatedUsers.length > 0){
            addedUserInProject = associatedUsers.map((user)=>{return user._id})
            setSelectedUsers(addedUserInProject);
          }

          // setApprovedSteps([
          //   project?.data?.approvals?.scriptsAndVisuals || false,
          //   project?.data?.approvals?.voiceOver || false,
          //   project?.data?.approvals?.video || false,
          // ]);
  
          let topic = [];
          
          if(project?.data?.topics.length == 7) {
            
            topic = project.data.topics.map((data)=>{
              const words = data.text.trim().split(/\s+/).filter(Boolean).length;
              let num ='';
              let match = data.topicNumber.match(/\d+/);

              num = match ? parseInt(match[0], 10) : 'opening';
              
              if(data.topicNumber == 'opening' || data.topicNumber == 'closing' ) {
                num = data.topicNumber
              }

              
              const numWords = {
                opening: "opening", 1: "one", 2: "two", 3: "three", 4: "four", 5: "five", closing: "closing"
              };
              let visualNote = data?.visualNote? data.visualNote:'';

              let title = numWords[num]
              let titleName = ''
              if(num == 'opening'){
                titleName = 'opening'
              } else if(num == 'closing') {
                titleName = 'closing'
              } else {
                titleName = `Topic ${title}`
              }
              return { title: titleName, content: data.text, wordCount: words, visualNote: visualNote, _id: data?._id,  };
            });
            
          } else {
            if (project?.data?.topics?.length > 0) {
              // Mapping digits back to words
              const numToWord = { opening: "opening", 1: "one", 2: "two", 3: "three", 4: "four", 5: "five", closing: "closing"};
            
              // Store existing topics in a map
              let topicMap = new Map();
            
              project.data.topics.forEach((data) => {
                const words = data.text.trim().split(/\s+/).filter(Boolean).length;
                // Extract number from topicNumber (e.g., "topic 4" -> 4)
                let match = data.topicNumber.toLowerCase().match(/\d+/);
                let num = match ? parseInt(match[0], 10) : "opening";
                
                if(data.topicNumber == 'opening' || data.topicNumber == 'closing' ) {
                  num = data.topicNumber
                }

                let visualNote = data?.visualNote? data.visualNote:'';

                let title = numToWord[num]; // Convert to word (1 -> "one", 2 -> "two", etc.)
                let titleName = ''

                let isClosing = false;
                let isOpeningAndTopic = true
                if(num == 'opening'){
                  isOpeningAndTopic = false
                  titleName = 'opening'
                } else if(num == 'closing') {
                  titleName = 'closing'
                  isClosing = true
                } else {
                  isOpeningAndTopic = false
                  titleName = `Topic ${title}`
                }

                if(!isClosing && isOpeningAndTopic) {
                  
                  topicMap.set('closing', { title: 'closing', content: '', wordCount: '', visualNote: '' });
                } else {
                  
                  topicMap.set(title, { title: titleName, content: data.text, wordCount: words, visualNote: visualNote, _id: data?._id  });
                }
              });
  
              topic = topicsData.map((defaultTopic) => {
                let key = defaultTopic.title.replace("Topic ", "").toLowerCase();
                return topicMap.get(numToWord[key]) || defaultTopic;
              });
            } else {
              topic = topicsData2
            }
            
          }

          let projectNewData = {
            ...project.data
          }
          projectNewData.topics = topic
  
          // Calculate activeStep based on approvals
          const activeStep = projectNewData.approvals.scriptsAndVisuals 
          ? projectNewData.approvals.voiceOver 
            ? projectNewData.approvals.video 
              ? 2 
              : 2 
            : 1 
          : 0;
  
          setActiveStep(activeStep)
  
          handleTotalWordCount(projectNewData.topics);
          setProject(projectNewData);
          setOriginalProject(projectNewData);
        }
      } catch(error) {
        console.log('error', error)
      }

      try {
        if(id){
          const response = await getProductionTeam();
          const orgUsers = await getUsersByOrgId(id);
          const orgDetailWithTemplateInfo = await getOrganizationTemplateById(id, { headers: {
              'Content-Type': 'multipart/form-data',
              'x-access-token': userDetails?.jwtToken || ''
            } 
          });

          setOrgDetailsWithTemplate(orgDetailWithTemplateInfo.organization);

          let userList = [...response.data, ...orgUsers.data];
          if(addedUserInProject.length > 0){

            // let projectUsers = addedUserInProject.map((user)=>user === )
            // Using filter and some
            const commonUsers = userList.filter(user1 => 
              addedUserInProject.some(user2 => user2 === user1._id)
            );
            setAssociatedUser(commonUsers);
            setLoading(false)
          }
          const userWithImage = userList.find((user)=>user._id == userDetails._id)
          setCurrentUser(userWithImage);
          setProductionTeam(response.data);
          setOrgCustomer(orgUsers.data);
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        setLoading(false)
      }
    }

    fetchProject()
  }, [])

  console.log('project', project);
  const subscriberTypeFromProject = project?.orgId?.subscriberType || '';
  const subscriberTypeFromUser = userDetails?.subscriberType || (userDetails?.org && userDetails.org.subscriberType) || '';
  const subscriberType = (subscriberTypeFromProject || subscriberTypeFromUser || '').toString().toLowerCase();
  const isFullAutomated = subscriberType && (subscriberType.includes('full') && subscriberType.includes('automated') || subscriberType === 'automated' || subscriberType === 'full-automated' || subscriberType === 'full automated');
  console.log('is full automated', isFullAutomated);

  const handleTextChange = (index, value) => {
    setIsChangedScript(true);
    const words = value.trim().split(/\s+/).filter(Boolean).length;
    const updatedTopics = [...project.topics];
    updatedTopics[index].content = value;
    updatedTopics[index].wordCount = words;

    const updatedProject = {
      ...project,
      topics: project.topics.map((topic, i) =>
          i === index ? { ...topic, content: value, wordCount: words } : topic
      )
    };
    setForOneTimeRender(false)
    handleTotalWordCount(updatedTopics)
    setProject(updatedProject);
  };
  
  const handleVisualChange = (index, value) => {
    setIsChangedScript(true);
    const updatedTopics = [...project.topics];
    updatedTopics[index].visualNote = value;

    const updatedProject = {
      ...project,
      topics: project.topics.map((topic, i) =>
          i === index ? { ...topic, visualNote: value } : topic
      )
    };
    setForOneTimeRender(false)
    setProject(updatedProject);
  };


  const handleTotalWordCount = (topics)=> {
    const total = topics.reduce(
      (sum, topic) => sum + topic.wordCount,
      0
    );
    setTotalWordCount(total)
  }

  const handleApproveStep = (stepIndex) => {
    const newApprovedSteps = [...approvedSteps];
    newApprovedSteps[stepIndex] = true;
    setApprovedSteps(newApprovedSteps);
  };

  const handleApprove = async (stage) => {
    try {
      setIsStageApproving(true)
      // let approvals = ['scriptsAndVisuals', 'voiceOver', 'video']
      // const approve = await approveProject(projectId, {stage: approvals[activeStep]});
      const approve = await approveProject(projectId, {stage: stage, userId: userDetails._id}, {
        headers: {
          "x-access-token": userDetails.jwtToken,
        },
      });
      
      if(approve.success){
        if(approve.data.approvals.video) {
          
          showMessage('Video approved', 'success');
          // setIsStageApproving(false)
          setProject(prev => ({
            ...prev,
            approvals: approve.data.approvals
            // approvals: {
            //   ...prev.approvals,
            //   video: true
            // }
          }));
          // handleApproveStep(2);
          // setActiveStep(3)
        } else if(approve.data.approvals.voiceOver){
          
          showMessage('Voice over approved', 'success');
          setActiveStep(2)
          // setIsStageApproving(false)
          setProject(prev => ({
            ...prev,
            approvals: {
              ...prev.approvals,
              voiceOver: true
            }
          }));
          // handleApproveStep(1);
        } else if(approve.data.approvals.scriptsAndVisuals) {
          showMessage('Script approved', 'success');
          setActiveStep(1)
          // setIsStageApproving(false)
          setProject(prev => ({
            ...prev,
            approvals: {
              ...prev.approvals,
              scriptsAndVisuals: true
            }
          }));
          // handleApproveStep(0);
        };
      }
      // if (activeStep < steps.length - 1) {
      //   setActiveStep(activeStep + 1);
      // }
    } catch(err) {
      console.log('err', err);
      // setIsStageApproving(false)
      showMessage('Stage is not approved', 'error')
    } finally {
      setIsStageApproving(false)
      // setLoading(false);
      setModalOpen(false);
    }

  };

  const handleTopicUpdate = async ()=>{
    setUpdatingScript(true);
    setDisableScriptPopUpBtn(true);
    console.log('in handleTopicUpdate');
    let projectTopicsForScript = [...project.topics]
    const wordToNum = { opening: "opening", one: 1, two: 2, three: 3, four: 4, five: 5, closing: "closing" };
    const newTopic = project.topics.map((topic, index)=>{
      if(topic.title.toLowerCase() == 'opening' || topic.title.toLowerCase() == 'closing'){
        return { topicNumber: topic.title.toLowerCase(), text: topic.content, visualNote: topic.visualNote};
      } else {
        let match = topic.title.match(/Topic (\w+)/i); // Extracts the word (e.g., "five", "four", etc.)
        if (match) {
          let numWord = match[1].toLowerCase();
          let num = wordToNum[numWord];
          if (num) {
            return { topicNumber: `topic ${num}`, text: topic.content, visualNote: topic.visualNote}; 
          }
        }
      }
      // return {topicNumber: topic., text: }
    })
    
    try {
      const topic = await updateProjectTopic(projectId, {topics: newTopic}, {headers: {
          "x-access-token": userDetails.jwtToken,
        }})
      
      showMessage(topic.message, "success");
      const updatedProject = {
        ...originalProject,
        isScriptUpdated: true,
        topics: projectTopicsForScript
      };
      setOriginalProject(updatedProject);
      console.log('in update topic function')
      setForOneTimeRender(true)
      setIsChangedScript(false);
      setUpdatingScript(false);
      setDisableScriptPopUpBtn(false);
      setConfirmModalScript(false);
    } catch(err) {
      showMessage(err?.response?.data?.message, "error");
      setUpdatingScript(false);
    }
  }

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };
  const handleNext = () => {
    if (activeStep < steps.length ) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleUserAddToProject = async()=>{
    setIsUpdatingLoader(true)
    try {
      const data = {
        associatedUser: selectedUsers
      }
      console.log('selectedUsers', selectedUsers)
      const projectUsers = await addUserToProject(project._id, data, {
        headers: {
          "x-access-token": userDetails.jwtToken,
        },
      });

      console.log('projectUsers', projectUsers)

      const associatedIds = projectUsers?.data?.associatedUsers || [];

      const newUsers = tempSelectedUser.filter(
        (user) => associatedIds.includes(user._id)
      );
      
      console.log('associatedIds', associatedIds);
      console.log('project.associatedUsers', project.associatedUsers);

      const projectUser = project.associatedUsers.filter(
        (user) => associatedIds.includes(user._id)
      );
      console.log('newUsers', newUsers)
      console.log('projectUser', projectUser)

      let allUserArray = [...projectUser, ...newUsers];
      allUserArray = allUserArray.filter((user, index, self) =>
        index === self.findIndex((u) => u._id === user._id)
      );
      console.log('allUserArray', allUserArray)

      // setDisplayedUsers([...projectUser, ...newUsers].slice(0, 3));
      setDisplayedUsers(allUserArray.slice(0, 3));
      setAllUsersForDisplay(allUserArray);
      setExtraCount(allUserArray.length > 3 ? allUserArray.length - 3 : 0);

      setProject((prev) => ({
        ...prev,
        associatedUsers: [
          ...(prev.associatedUsers),
          ...newUsers,
        ],
      }));
      setIsUpdatingLoader(false)
      setOpen(false)
      showMessage('Changes to project users saved.', 'success')
      
    } catch(error) {
      console.log('error', error);
      setIsUpdatingLoader(false)
      setOpen(false)
      showMessage(error?.response?.data?.message || 'Internal server issue', 'error')
    } finally {
      setIsUpdatingLoader(false)
      setOpen(false)
    }
  }
  
  const generateAndUploadPDF = async () => {
    const input = pdfRef.current;
    console.log('input', input)
    if (!input) {
      showMessage("Unable to capture content. Please ensure scripts are updated before proceeding with approval.", "error");
    };
    
    try {

    setIsStageApproving(true)
    setDisableScriptPopUpBtn(true);
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // Try multiple selectors to find the title section
    let titleSection = document.querySelector(".MuiPaper-elevation3");

    // If first selector doesn't work, try alternatives
    if (!titleSection) {
      titleSection = document.querySelector('.MuiPaper-root[elevation="3"]');
    }

    if (!titleSection) {
      titleSection = document.querySelector("div.MuiPaper-root");
    }


    // Get all the card elements
    const cards = document.querySelectorAll(".MuiCard-root");

    let yPosition = 10; // Starting y position with margin
    let pageNumber = 1;

    // First add the title section
    if (titleSection) {
      try {
        // Make sure the title section is visible
        titleSection.style.display = "block";
        titleSection.style.visibility = "visible";

        const titleCanvas = await html2canvas(titleSection, {
          scale: 2,
          logging: true,
          useCORS: true,
          allowTaint: true,
        });

        const titleImgData = titleCanvas.toDataURL("image/png");
        const titleImgWidth = pdfWidth - 20; // Leave some margin
        const titleImgHeight =
          (titleCanvas.height * titleImgWidth) / titleCanvas.width;

        // Add the title to the first page
        pdf.addImage(
          titleImgData,
          "PNG",
          10,
          yPosition,
          titleImgWidth,
          titleImgHeight
        );
        yPosition += titleImgHeight + 10; // Add spacing after title
      } catch (error) {
        console.error("Error capturing title:", error);

        addManualTitle(pdf, pdfWidth, yPosition);
        yPosition += 40;
      }
    } else {
      console.error("Title section not found!");

      // Since we couldn't find the element, add a manual title
      addManualTitle(pdf, pdfWidth, yPosition);
      yPosition += 40;
    }

    // Process each card individually
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];

      try {
        const cardCanvas = await html2canvas(card, {
          scale: 2,
          logging: false,
          useCORS: true,
          allowTaint: true,
        });

        const cardImgData = cardCanvas.toDataURL("image/png");
        const cardImgWidth = pdfWidth - 20; // Leave some margin
        const cardImgHeight = (cardCanvas.height * cardImgWidth) / cardCanvas.width;

        // Check if this card will fit on the current page
        if (yPosition + cardImgHeight > pdfHeight - 10) {
          pdf.addPage();
          yPosition = 10; // Reset for new page
          pageNumber++;
        }

        // Add the card to the PDF
        pdf.addImage(
          cardImgData,
          "PNG",
          10,
          yPosition,
          cardImgWidth,
          cardImgHeight
        );
        yPosition += cardImgHeight + 10; // Space for next card
      } catch (error) {
        console.error(`Error processing card ${i + 1}:`, error);
      }
    }

    const blob = pdf.output("blob");

      try {
        const formData = new FormData();
  
        formData.append("scriptFile", blob, `${project.projectName}.pdf`);
        formData.append("stage", 'scriptsAndVisuals');
  
        const approve = await uploadProjectScriptFile(project._id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": userDetails?.jwtToken
          },  
        });
        // let newProject = { ...projectDetail };
        // newProject.approvedVideoFileId =
        //   projectNew.data.approvedVideoFileId;
        // setProjectDetail(newProject);
        // setIsSubmit(false);
        // showMessage(projectNew.message, "success");
        // handleApprove("scriptsAndVisuals");
        if(approve.success){
          console.log('approve', approve)
          if(approve.data.approvals.scriptsAndVisuals) {
            setIsScriptApproving(false);
            setDisableScriptPopUpBtn(false);
            showMessage('Script approved', 'success');
            if(approve.data.approvals.voiceOver) {
              setActiveStep(2)
            } else {
              setActiveStep(1)
            }
            setConfirmModalScript(false)
            setProject(prev => ({
              ...prev,
              approvals: {
                // ...prev.approvals,
                // scriptsAndVisuals: true
                ...approve.data.approvals
              }
            }));
          };
        }
      } catch (err) {
        // setIsSubmit(false);
        setIsScriptApproving(false);
        showMessage(err?.response?.data?.message, "error");
      } finally {
        setIsStageApproving(false)
        setConfirmModalScript(false)
        // setLoading(false);
        setModalOpen(false);
      }

    } catch (error) {
      setIsScriptApproving(false);
      console.error('PDF generation/upload failed:', error);
    } finally {
      setIsStageApproving(false)
      // setLoading(false);
      setModalOpen(false);
    }
  };

  // Helper function to add a manual title if capturing fails
  function addManualTitle(pdf, pdfWidth, yPosition) {
    // Create a title section manually
    pdf.setFillColor(248, 249, 250); // #f8f9fa background color
    pdf.roundedRect(10, yPosition, pdfWidth - 20, 30, 3, 3, 'F'); // Draw rounded rectangle
    
    pdf.setFontSize(24);
    pdf.setTextColor(44, 62, 80); // #2c3e50
    pdf.setFont("helvetica", "bold");
    pdf.text("Script", pdfWidth/2, yPosition + 12, { align: "center" });
    
    pdf.setFontSize(14);
    pdf.setTextColor(127, 140, 141); // #7f8c8d
    pdf.setFont("helvetica", "normal");
    pdf.text("Complete script with visual notes", pdfWidth/2, yPosition + 22, { align: "center" });
    
  }

  const handleApproveModal = (stage) => {
    if(!approvedVoiceOverFileId && stage == 'voiceOver') {
      console.log('userDetails in voice over condition', userDetails)
      if(userDetails?.role == 'subscriber') {
        showMessage('The editor hasn’t uploaded the voice-over yet. Please wait until the voice-over is available before approving.', 'error')
        return
      }
      showMessage('Please upload voice over file before approving', 'error')
      return
    } else if (stage === 'video') {
      const isSubscriber = userDetails?.role === 'subscriber';

      if(isFullAutomated) {
        if (!approvedVideoFileId) {
          showMessage('In full automated plans, video files are generated automatically. Please wait until the videos are available before approving.', 'error');
          return;
        }
      } else {
        if (!approvedVideoFileId && !approvedVerticalVideoFileId) {
          if (isSubscriber) {
            showMessage(
              'The editor hasn’t uploaded the horizontal and vertical video yet. Please wait until the video is available before approving.',
              'error'
            );
          } else {
            showMessage(
              'Please upload horizontal and vertical video files before approving.',
              'error'
            );
          }
          return;
        }
  
        if (!approvedVerticalVideoFileId) {
          if (isSubscriber) {
            showMessage(
              'The editor hasn’t uploaded the vertical video yet. Please wait until the video is available before approving.',
              'error'
            );
          } else {
            showMessage(
              'Please upload vertical video file before approving.',
              'error'
            );
          }
          return;
        }
  
        if (!approvedVideoFileId) {
          if (isSubscriber) {
            showMessage(
              'The editor hasn’t uploaded the horizontal video yet. Please wait until the video is available before approving.',
              'error'
            );
          } else {
            showMessage(
              'Please upload horizontal video file before approving.',
              'error'
            );
          }
          return;
        }
      }
    }
    // } else if(!approvedVideoFileId && !approvedVerticalVideoFileId && stage == 'video'){
    //   if(userDetails?.role == 'subscriber') {
    //     if(!approvedVideoFileId && !approvedVerticalVideoFileId) {
    //       showMessage('The editor hasn’t uploaded the horizontal and vertical video yet. Please wait until the video is available before approving.', 'error')
    //       return
    //     }

    //     if(!approvedVideoFileId) {
    //       showMessage('The editor hasn’t uploaded the vertical video yet. Please wait until the video is available before approving.', 'error')
    //       return
    //     }
        
    //     if(!approvedVerticalVideoFileId) {
    //       showMessage('The editor hasn’t uploaded the horizontal video yet. Please wait until the video is available before approving.', 'error')
    //       return
    //     }
    //   }

    //   if(!approvedVideoFileId && !approvedVerticalVideoFileId) {
    //     showMessage('Please upload horizontal and vertical video file before approving', 'error')
    //     return
    //   }

    //   if(!approvedVideoFileId) {
    //     showMessage('Please upload horizontal video file before approving', 'error')
    //     return
    //   }
      
    //   if(!approvedVerticalVideoFileId) {
    //     showMessage('Please upload vertical video file before approving', 'error')
    //     return
    //   }

    // }

    console.log(' approvedVerticalVideoFileId', approvedVerticalVideoFileId)
        console.log(' approvedVideoFileId', approvedVideoFileId)
        console.log(' !approvedVideoFileId && !approvedVerticalVideoFileId && stage == video', !approvedVideoFileId, !approvedVerticalVideoFileId, stage == 'video')
    setModalOpen(true);
    setApproveStageName(stage);
  }
 
  const handleProceedWithoutSaving =async () => {
    if(isFullAutomated){
      setConfirmModalScript(false);
      await handleGenerateClick();
    } else {
      generateAndUploadPDF();
    }
  };

  const handleSaveAndContinue = async () => {
    try {
      await handleTopicUpdate();
      // generateAndUploadPDF();
    } catch (error) {
      console.error("Error saving and continuing:", error);
    }
  };

  const handleSave = (data) => {
    console.log('Saved Visual:', data);
    let topic = data.topics.map((data)=>{
      const words = data.text.trim().split(/\s+/).filter(Boolean).length;
      let num ='';
      let match = data.topicNumber.match(/\d+/);

      num = match ? parseInt(match[0], 10) : 'opening';
      
      if(data.topicNumber == 'opening' || data.topicNumber == 'closing' ) {
        num = data.topicNumber
      }

      
      const numWords = {
        opening: "opening", 1: "one", 2: "two", 3: "three", 4: "four", 5: "five", closing: "closing"
      };
      let visualNote = data?.visualNote? data.visualNote:'';

      let title = numWords[num]
      let titleName = ''
      if(num == 'opening'){
        titleName = 'opening'
      } else if(num == 'closing') {
        titleName = 'closing'
      } else {
        titleName = `Topic ${title}`
      }
      return { title: titleName, content: data.text, wordCount: words, visualNote: visualNote, _id: data?._id,  };
    });

    setProject({ ...project, topics: topic });
  };

  const fetchSceneImagesForTopic = async (topicId) => {
    if (!project || !project._id || !topicId) return [];
    try {
      const ids = { projectId: project._id, topicId };
      const response = await getSceneImagesByProjectIdAndTopicId(ids, {
        headers: { "x-access-token": userDetails?.jwtToken }
      });
      const sceneFiles = response?.sceneFiles || [];
      setSceneImagesMap(prev => ({ ...prev, [topicId]: sceneFiles }));
      return sceneFiles;
    } catch (err) {
      console.error('fetchSceneImagesForTopic error', err);
      showMessage('Failed to load scene images', 'error');
      return [];
    }
  };

  const handleSceneUploadSave = async (resp) => {
    if (selectedSceneUploaderId && selectedSceneUploaderId.topicId) {
      await fetchSceneImagesForTopic(selectedSceneUploaderId.topicId);
    }
  };

  useEffect(() => {
    if (project && project.topics && project.topics.length > 0) {
      project.topics.forEach(topic => {
        if (topic._id) fetchSceneImagesForTopic(topic._id);
      });
    }
  }, [project?._id]);


  // Warn on browser close or refresh
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isChangedScript) {
        e.preventDefault();
        e.returnValue = ""; // Required for Chrome
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isChangedScript]);


  function updateProjectTopicsFromAi(data) {
    console.log('updateProjectTopicsFromAi called with project:', data);
    if (!project || !Array.isArray(project.topics)) return project;

    const formattedData = data.map((item) => ({
      topicNumber: item.topicNumber.toLowerCase().trim(),
      text: item.text.trim(),
    }));

    const updatedTopics = project.topics.map((topic) => {
      const match = formattedData.find(
        (item) => item.topicNumber === topic.title.toLowerCase().trim()
      );
      if (match) {
        return {
          ...topic,
          content: match.text,
          wordCount: match.text.split(/\s+/).filter(Boolean).length,
        };
      }
      return topic;
    });
    
    setProject({ ...project, topics: updatedTopics });
    // Recompute total word count when topics are updated programmatically
    try {
      handleTotalWordCount(updatedTopics);
      setIsChangedScript(true);
    } catch (e) {
      // noop
    }
  }

  // Fetch status for a ProjectVideoVersion and update local state
  const fetchVersionStatus = async (idOrProjectId, opts = { byProject: false }) => {
    if (!idOrProjectId) return null;
    try {
      let resp;
      if (opts.byProject) {
        resp = await getProjectVideoVersionStatusByProject(idOrProjectId, { headers: { 'x-access-token': userDetails?.jwtToken } });
      } else {
        resp = await getProjectVideoVersionStatusById(idOrProjectId, { headers: { 'x-access-token': userDetails?.jwtToken } });
      }
      console.log('fetchVersionStatus resp', resp);
      const status = resp?.status || resp?.data?.status || resp?.version?.status || resp?.version?.status;
      const progress = resp?.progress || resp?.data?.progress || resp?.version?.progress;
      setVersionStatus(status || '');
      setIsGenerating(status === 'processing' || status === 'queued');
      return { status, progress, payload: resp };
    } catch (err) {
      console.error('fetchVersionStatus error', err);
      return null;
    }
  };

  // removed polling; use single checks instead

  const handleGenerateClick = async () => {
    console.log('handleGenerateClick called');
    if (!project || !project._id) return;
    console.log('handleGenerateClick called --', project);
    console.log('project id:', project._id);
    // if (isChangedScript) {
    //   setConfirmModalScript(true);
    //   return;
    // }

    try {
      setIsGenerating(true);
      const resp = await generateHeygenVideos(project._id, { headers: { 'x-access-token': userDetails?.jwtToken } });
      console.log('generateHeygenVideos resp', resp);
      // Response shapes vary; try to find the created version id
      const versionDoc = resp?.data?.version || resp;
      const versionId = versionDoc?._id || versionDoc?.id || resp?._id || resp?.id;
      showMessage('Video generation started', 'success');
      // if (versionId) {
      //   setGeneratedVersionId(versionId);
        // localStorage.setItem(`project_${project._id}_videoVersionId`, versionId);
      //   // perform a one-time status fetch to update UI
      //   await fetchVersionStatus(versionId);
      //   showMessage('Video generation started', 'success');
      // } else {
      //   // no id returned but still set generating; attempt to clear after a short time
      //   showMessage('Video generation requested', 'success');
      //   // setTimeout(() => setIsGenerating(false), 5000);
      // }
    } catch (err) {
      console.error('generateHeygenVideos error', err);
      showMessage(err?.response?.data?.message || 'Failed to start video generation', 'error');
      setIsGenerating(false);
    }
  };


  const handleGenerateInitiate = () => {
    // Validate that all topics have content before allowing generation
    if (!project || !Array.isArray(project.topics) || project.topics.length === 0) {
      showMessage('Please fill all topics before generating the video.', 'error');
      return;
    }
    const missing = project.topics.some((t) => {
      const content = (t.content || t.text || '').toString().trim();
      return content.length === 0;
    });
    if (missing) {
      showMessage('Please fill all topics before generating the video.', 'error');
      return;
    }

    // Validate total word count does not exceed 225 words
    const totalWords = project.topics.reduce((sum, t) => {
      const cnt = t.wordCount || (t.content || t.text || '').toString().trim().split(/\s+/).filter(Boolean).length;
      return sum + (Number.isFinite(cnt) ? cnt : 0);
    }, 0);
    if (totalWords > 225) {
      showMessage('Please reduce the script to at most 225 words before generating the video.', 'error');
      return;
    }

    if (isChangedScript) {
      setConfirmModalScript(true);
      return;
    }

    setConfirmGenerateModalOpen(true);
  };

  // On mount / when project is available, resume polling if we have a saved version id
  useEffect(() => {
    if (!project || !project._id) return;
    const saved = localStorage.getItem(`project_${project._id}_videoVersionId`);
    if (saved) {
      // saved used to be a versionId; switch to project-based check — call by project id
      // we store project id key as `project_<project._id>_videoVersionId` previously
      // perform a one-time status check using project id
    }
    fetchVersionStatus(project._id, { byProject: true });
  }, [project?._id]);


  return (
    <>
      {loading ? (
        <Box sx={override}>
          <BeatLoader
            color={theme.palette.primary.main}
            loading={loading}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </Box>
      ) : (
        <Box>
          <Grid2 container spacing={2} sx={{ height: "98vh" }}>
            <Grid2 size={{ xs: 12, md: 8 }}>
              <Stack direction="row" justifyContent="space-between">
                <Box sx={{ mb: 3, display: 'flex', gap: 1, alignItems: 'center'}}>
                  <Typography variant="h2">{project.projectName} </Typography>
                  {orgDetailsWithTemplate && <ProjectInfo template={orgDetailsWithTemplate?.templateId}/>}
                </Box>
                <Box>
                  {/* Display Selected Users */}
                  <Box display="flex" alignItems="center" gap={1}>
                    {displayedUsers.map((dUser) => {
                      const user = project?.associatedUsers.find(
                        (u) => u._id === dUser._id
                      );

                      return (
                        <Avatar
                          key={user._id}
                          src={user?.profilePicture || user?.linkedinProfilePic || "/default-avatar.png"}
                          alt={user?.firstName}
                        />
                      );
                    })}

                    {extraCount > 0 && (
                      <Avatar sx={{ bgcolor: "#ccc", fontSize: "14px" }}>
                        +{extraCount}
                      </Avatar>
                    )}

                    <IconButton
                      onClick={() => setOpen(true)}
                      sx={{ border: "1px solid #ccc", borderRadius: "50%" }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>

                  {/* Modal for User Selection */}
                  <Modal open={open} onClose={() => setOpen(false)}>
                    <Box
                      sx={{
                        width: 800,
                        background: "#fff",
                        margin: "100px auto",
                        padding: 2,
                        borderRadius: 2,
                      }}
                    >
                      { userDetails && userDetails.role == 'admin' ? 
                        <>  
                          <Typography variant="h5" fontWeight="bold">Add User To Project</Typography>
                          <List>
                            <Grid2 container>
                              {productionTeam.map((user) => (
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                  <ListItem
                                    key={user._id}
                                    onClick={() => handleToggle(user._id, user)}
                                    button
                                  >
                                    <ListItemIcon>
                                      <Checkbox
                                        checked={selectedUsers.includes(user._id)}
                                      />
                                    </ListItemIcon>
                                    <Avatar
                                      src={
                                        user.profilePicture || user?.linkedinProfilePic || "/default-avatar.png"
                                      }
                                      alt={`${user.firstName} ${user.lastName}`}
                                      sx={{ marginRight: 1 }}
                                    />
                                    <ListItemText
                                      primary={`${user.firstName} ${user.lastName}`}
                                    />
                                  </ListItem>
                                </Grid2>
                              ))}
                            </Grid2>
                            <Divider />
                            <Grid2 container>
                              {orgCustomer.map((user) => (
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                  <ListItem
                                    key={user._id}
                                    onClick={() => handleToggle(user._id, user)}
                                    button
                                  >
                                    <ListItemIcon>
                                      <Checkbox
                                        checked={selectedUsers.includes(user._id)}
                                      />
                                    </ListItemIcon>
                                    <Avatar
                                      src={
                                        user.profilePicture || user?.linkedinProfilePic || "/default-avatar.png"
                                      }
                                      alt={`${user.firstName} ${user.lastName}`}
                                      sx={{ marginRight: 1 }}
                                    />
                                    <ListItemText
                                      primary={`${user.firstName} ${user.lastName}`}
                                    />
                                  </ListItem>
                                </Grid2>
                              ))}
                            </Grid2>
                          </List>
                          <Stack direction="row" gap="10px" justifyContent="end">
                            <Button
                              variant="contained"
                              sx={{ textAlign: "end" }}
                              onClick={() => setOpen(false)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{ textAlign: "end" }}
                              onClick={handleUserAddToProject}
                              disabled={isUpdatingLoader}
                            >
                              Update
                            </Button>
                          </Stack>
                        </>
                        :
                          <>
                            <Typography variant="h5" fontWeight="bold">Users</Typography>
                            <List>
                              <Grid2 container>
                                {allUsersForDisplay.map((user) => (
                                  <Grid2 size={{ xs: 12, md: 6 }}>
                                    <ListItem
                                      key={user._id}
                                      button
                                    >
                                      <Avatar
                                        src={
                                          user.profilePicture || user?.linkedinProfilePic || "/default-avatar.png"
                                        }
                                        alt={`${user.firstName} ${user.lastName}`}
                                        sx={{ marginRight: 1 }}
                                      />
                                      <ListItemText
                                        primary={`${user.firstName} ${user.lastName}`}
                                      />
                                    </ListItem>
                                  </Grid2>
                                ))}
                              </Grid2>
                            </List>
                          </>
                      }
                    </Box>
                  </Modal>
                </Box>
              </Stack>

              <Divider />

              <Box
                sx={{
                  height: { xs: "auto", md: "91vh" },
                  display: "flex",
                  flexDirection: "column",
                  mt: "10px",
                }}
              >
                {/* Stepper (Fixed at Top) */}
                <Box sx={{ flexShrink: 0, paddingBottom: '10px', marginBottom: '10px' }}>
                  {!isFullAutomated ? 
                    <Stepper activeStep={activeStep} alternativeLabel>
                      {steps.map((label, index) => (
                        <Step key={index}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    :
                    // <Stepper activeStep={activeStep} alternativeLabel>
                    //   {automatedSteps.map((label, index) => (
                    //     <Step key={index}>
                    //       <StepLabel>{label}</StepLabel>
                    //     </Step>
                    //   ))}
                    // </Stepper>
                    <>
                      {/* Project avatar (for automated projects) */}
                      {isFullAutomated && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
                          <Avatar
                            src={projectAvatar ? (getAvatarImageUrl(projectAvatar) || projectAvatar.preview_image_url) : '/default-avatar.png'}
                            alt={projectAvatar ? (projectAvatar.avatar_name || projectAvatar.name) : 'Select avatar'}
                            sx={{ width: 48, height: 48 }}
                          />
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle2">{projectAvatar ? (projectAvatar.avatar_name || projectAvatar.name) : 'Select avatar'}</Typography>
                            <Typography variant="caption" color="text.secondary">{projectAvatar ? projectAvatar.gender : ''}</Typography>
                          </Box>
                          <IconButton size="small" onClick={() => setAvatarModalOpen(true)} sx={{ ml: 1 }} aria-label="change-avatar">
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      )}
                    </>
                  }
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {
                      isFullAutomated ?
                      <Typography variant="h3" fontWeight="bold" mt={2}>
                        {automatedSteps[activeStep]}
                      </Typography>
                      :
                      <Typography variant="h3" fontWeight="bold" mt={2}>
                        {steps[activeStep]}
                      </Typography>
                    }
                    {
                      activeStep == 0 && 
                      <Box sx={{textAlign: 'right', p: '10px 15px 0px 0px'}}>
                        {project?.approvals && (
                          <Button
                            variant={"contained"}
                            onClick={handleTopicUpdate}
                            disabled={project.approvals.scriptsAndVisuals || updatingScript}
                          >
                            {updatingScript? 'Saving...': 'save'}
                          </Button>
                        )}
                      </Box>
                    }
                  </Box>
                </Box>

                <>
                  {/* Scrollable Content */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      overflowY: "auto",
                      paddingRight: '10px',
                    }}
                  >
                    {activeStep === 0 && (
                      <>
                        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', maxHeight: 'calc(100vh - 380px)' }}>
                          {project &&
                            Object.keys(project).length > 0 &&
                            project?.topics.length > 0 &&
                            <Box sx={{ overflow: 'auto', height: '60vh', paddingRight: 2, display: 'flex', flexGrow: 1, flexDirection: 'column', gap: '34px', minHeight: 0, }}>
                              {
                                project?.topics.map((topic, index) => (
                                  <Paper
                                    key={index}
                                    sx={{
                                      padding: 2,
                                      // marginTop: 4,
                                      // marginBottom: 2,
                                      borderRadius: 2,
                                      boxShadow: 2,
                                      border: "1px solid #c5bbbb",
                                    }}
                                  >
                                    {/* <Typography variant="subtitle1" fontWeight="bold">
                                      {topic.title}
                                    </Typography> */}
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                      <Typography variant="subtitle1" fontWeight="bold" textTransform="capitalize">
                                        {topic.title}
                                      </Typography>

                                      <Box sx={{ display: 'flex', gap: 1 }}>
                                        { isFullAutomated && topic.title.toLowerCase() != 'opening' && topic.title.toLowerCase() != 'closing' && <Tooltip title="Add images to scene">
                                          <IconButton onClick={async () => {
                                            const files = await fetchSceneImagesForTopic(topic._id);
                                            const existingFiles = (files || []).flatMap(v => v.files || []);
                                            const imageCount = existingFiles.filter(f => /\.(jpe?g|png|gif|bmp|tiff|webp)$/i.test(f.fileOriginalName)).length;
                                            if (imageCount >= 3) {
                                              showMessage('You can upload up to 3 images for a scene', 'error');
                                              return;
                                            }
                                            console.log('topic in add images', topic)
                                            setSelectedSceneUploaderId({ topicId: topic._id, topicTitle: topic.title });
                                            setOpenSceneUploader(true);
                                          }}>
                                            <AddPhotoAlternateIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>}
                                        <IconButton onClick={() => setOpenEditor({ index, type: "script", title: topic.title })}>
                                          <FullscreenIcon fontSize="small" />
                                        </IconButton>
                                      </Box>
                                    </Box>
                                    <TextField
                                      className={"topic-text"}
                                      fullWidth
                                      multiline
                                      rows={2}
                                      value={topic.content}
                                      onChange={(e) =>
                                        handleTextChange(index, e.target.value)
                                      }
                                      placeholder={`Enter script for ${topic.title}`}
                                      sx={{ marginTop: 1 }}
                                    />
                                    {/* Scene thumbnails (separate from visual notes) */}
                                    <Box sx={{ display: 'flex', gap: 1, mt: 1, justifyContent: 'space-between' }}>
                                      <Box sx={{ display: 'flex', gap: 1 }}>
                                        {sceneImagesMap[topic._id] && sceneImagesMap[topic._id].length > 0 ? (
                                          sceneImagesMap[topic._id].flatMap(s => s.files || []).slice(0,3).map((file, fi) => (
                                            <Box key={fi} sx={{ width: 64, height: 64, border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden', cursor: 'pointer' }} onClick={() => { setOpenSceneUploader(true); setSelectedSceneUploaderId({ topicId: topic._id, topicTitle: topic.title }); }}>
                                              <img src={file.fileUrl} alt={file.fileOriginalName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            </Box>
                                          ))
                                        ) : null}
                                      </Box>
                                      <Typography
                                        variant="caption"
                                        sx={{ display: "block", marginTop: 1 }}
                                      >
                                        Word Count: {topic.wordCount}
                                      </Typography>
                                    </Box>
                                    {/* <Typography variant="subtitle1" fontWeight="bold">
                                      Visual Note
                                    </Typography> */}
                                    { !isFullAutomated && <>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 3 }}>
                                        <Typography variant="subtitle1" fontWeight="bold">
                                          Visual Notes
                                        </Typography>
                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                          {/* <Tooltip title="Add images to scene">
                                            <IconButton onClick={() => {
                                              
                                            }}>
                                              <AddPhotoAlternateIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip> */}
                                          
                                          <Tooltip title="Preview Visuals Notes">
                                            <IconButton onClick={() => {
                                              setOpenVisualPreview(true);
                                              setSelectedVisualPreviewId(topic);
                                            }}>
                                              <FolderOpenIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>

                                          <Tooltip title="Attach Visual Notes">
                                            <IconButton onClick={() => {
                                              setOpenVisualFileUploader(true);
                                              setSelectedVisualUploaderId({ topicId: topic._id, topicTitle: topic.title });
                                            }}>
                                              <AttachFileIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>

                                          <Tooltip title="Full Screen Editor">
                                            <IconButton onClick={() => setOpenEditor({ index, type: "visual" })}>
                                              <FullscreenIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        </Box>
                                      </Box>
                                      <TextField
                                        className={"topic-text"}
                                        fullWidth
                                        multiline
                                        // label="Visual Note"
                                        rows={2}
                                        value={topic.visualNote}
                                        onChange={(e) =>
                                          handleVisualChange(index, e.target.value)
                                        }
                                        placeholder={`Enter visual notes`}
                                        // sx={{ marginTop: 3 }}
                                      />
                                    </>}
                                  </Paper>
                                ))
                              }
                            </Box>
                          }
                        </Box>

                        <Modal 
                          open={openEditor.index !== null} 
                          onClose={() => setOpenEditor({ index: null, type: null })} 
                          closeAfterTransition
                          BackdropComponent={Backdrop}
                          BackdropProps={{ timeout: 500 }}
                        >
                          <Fade in={openEditor.index !== null}>
                            <Box
                              sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '90%',
                                height: '80vh',
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                boxShadow: 24,
                                p: 4,
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h4">
                                  {openEditor.type === "script"
                                    ? `Edit ${openEditor.title}`
                                    : "Edit Visual Note"}
                                </Typography>
                                <IconButton onClick={() => setOpenEditor({ index: null, type: null })}>
                                  <CloseIcon />
                                </IconButton>
                              </Box>

                              {/* This Box wraps the scrollable TextField */}
                              <Box sx={{ flexGrow: 1 }}>
                                {project?.topics &&
                                  Array.isArray(project.topics) &&
                                  typeof openEditor.index === 'number' &&
                                  openEditor.index >= 0 &&
                                  openEditor.index < project.topics.length &&
                                  project.topics[openEditor.index] && (
                                    <TextField
                                  className='modal-textarea'
                                  fullWidth
                                  multiline
                                  inputRef={inputRef}
                                  value={
                                    openEditor.type === "script"
                                      ? project.topics[openEditor.index]?.content || ''
                                      : project.topics[openEditor.index]?.visualNote || ''
                                  }
                                  onChange={(e) => {
                                    if (openEditor.type === "script") {
                                      handleTextChange(openEditor.index, e.target.value);
                                    } else {
                                      handleVisualChange(openEditor.index, e.target.value);
                                    }
                                  }}
                                  sx={{
                                    height: '100%',
                                    '& .MuiInputBase-root': {
                                      height: '100%',
                                      alignItems: 'start',
                                    },
                                    '& textarea': {
                                      height: '100% !important',
                                      overflow: 'auto',
                                    }
                                  }}
                                />
                                )}
                                
                              </Box>

                              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                <Button
                                  variant="contained"
                                  onClick={() => setOpenEditor({ index: null, type: null })}
                                >
                                  Done
                                </Button>
                              </Box>
                            </Box>
                          </Fade>
                        </Modal>

                        {/* Confirmation Dialog */}
                        <Dialog open={confirmModalScript} onClose={() => setConfirmModalScript(false)}>
                          <DialogTitle fontSize={18}>Unsaved Changes</DialogTitle>
                          <Divider />
                          <DialogContent>
                            You have unsaved changes to your script. Would you like to <strong>save</strong> before continuing or <strong>proceed without saving</strong>?
                          </DialogContent>
                          <DialogActions sx={{paddingRight: '20px'}}>
                            <Button onClick={handleSaveAndContinue} variant="contained" color="error" disabled={updatingScript || disableScriptPopUpBtn }>{updatingScript ? 'Save...' : 'Save and Continue'}</Button>
                            <Button onClick={handleProceedWithoutSaving} variant="contained" color="error" disabled={isStageApproving || disableScriptPopUpBtn }>{isStageApproving ? 'Proceeding...' : 'Proceed Without Saving'}</Button>
                            <Button onClick={() => setConfirmModalScript(false)} variant="outlined" color="inherit">Cancel</Button>
                          </DialogActions>
                        </Dialog>

                        <Dialog open={confirmGenerateModalOpen} onClose={() => setConfirmGenerateModalOpen(false)}>
                          <DialogTitle fontSize={18}>Generate Videos</DialogTitle>
                          <Divider />
                          <DialogContent>
                            Are you sure you want to generate the video? This will start the rendering process and may take several minutes.
                          </DialogContent>
                          <DialogActions sx={{paddingRight: '20px'}}>
                            <Button onClick={() => setConfirmGenerateModalOpen(false)} variant="outlined">Cancel</Button>
                            <Button onClick={async () => { setConfirmGenerateModalOpen(false); await handleGenerateClick(); }} variant="contained" color="error">Generate</Button>
                          </DialogActions>
                        </Dialog>

                          {/* Visual file uploader modal */}
                          <VisualFileUploadModal 
                            open={openVisualFileUploader}
                            onClose={() => setOpenVisualFileUploader(false)}
                            userDetails={userDetails}
                            projectId={project._id}
                            onSave={handleSave}
                            // onSave={(resp) => { handleSave(resp); handleVisualUploadSave && handleVisualUploadSave(resp); }}
                            topicDetail={selectedVisualUploaderId}
                            actionType={'upload'}
                          />

                          <SceneImageUploadModal
                            open={openSceneUploader}
                            onClose={() => setOpenSceneUploader(false)}
                            projectId={project._id}
                            topicDetail={selectedSceneUploaderId}
                            userDetails={userDetails}
                            onSave={handleSceneUploadSave}
                          />
                          
                          {/* Visual file preview modal */}
                          {openVisualPreview && selectedVisualPreviewId && (
                            <VisualPreviewModal 
                              open={openVisualPreview}
                              onClose={() => setOpenVisualPreview(false)}
                              projectId={project._id}
                              topicDetail={selectedVisualPreviewId}
                              userDetails={userDetails}
                            />
                          )}
                      </>
                    )}
                    {/* Step 2 */}
                    {activeStep === 1 && !isFullAutomated && (
                      <Box>
                        <CreateVoiceOverStage project={project} setProject={setProject} setApprovedVoiceOverFileId={setApprovedVoiceOverFileId}/>
                      </Box>
                    )}

                    {activeStep === 2 && (
                      <Box >
                        <CreateVideoStage project={project} setProject={setProject} setApprovedVideoFileId={setApprovedVideoFileId} setApprovedVerticalVideoFileId={setApprovedVerticalVideoFileId} isFullAutomated={isFullAutomated}/>
                      </Box>
                    )}
                  </Box>
                </>

                {/* Buttons (Fixed at Bottom) */}
                {activeStep === 0 && (
                  <Box >
                    <Box sx={{textAlign: 'right', p: '10px 15px 10px 0px', display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'end'}}>
                      {project?.approvals && userDetails.role == "admin" && (
                        <Button
                          variant={"contained"}
                          onClick={() => { setScriptGenerateModalOpen(true) }}
                          disabled={project.approvals.scriptsAndVisuals }
                        >
                          Create Script
                        </Button>
                      )}
                      {project?.approvals && (
                        <Button
                        variant={"contained"}
                        onClick={handleTopicUpdate}
                        disabled={project.approvals.scriptsAndVisuals || updatingScript}
                        >
                          {updatingScript? 'Saving...': 'save'}
                        </Button>
                      )}
                    </Box>
                    <Box
                      sx={{
                        flexShrink: 0,
                        paddingBottom: 2,
                        paddingRight: 2,
                        borderTop: "1px solid #919191",
                      }}
                    >
                      <Box mb="10px">
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          sx={{ marginTop: '10px' }}
                        >
                          Total Word Count: {totalWordCount}
                        </Typography>
                      </Box>
                      { !isFullAutomated ?
                        <Stack
                          direction="row"
                          justifyContent={
                            // userDetails.role == "admin" ? "space-between" : "end"
                            'space-between'
                          }
                          gap={2}
                          sx={{ paddingLeft: "15px" }}
                        >
                          {userDetails.role == "admin" && (
                            <Stack direction="row" gap={"10px"}>
                              <Button
                                variant="contained"
                                onClick={handleBack}
                                disabled={activeStep === 0}
                              >
                                Back
                              </Button>
                              <Button variant="contained" onClick={handleNext}>
                                Next
                              </Button>
                            </Stack>
                          )}
                          {userDetails?.role.toLowerCase() == "subscriber" && (
                            <Stack direction="row" gap={"10px"}>
                              <Button
                                variant="contained"
                                onClick={handleBack}
                                disabled={activeStep === 0}
                              >
                                Back
                              </Button>
                              {/* <Button variant="contained" onClick={handleNext} disabled={(activeStep === 2 || !project?.approvals?.scriptsAndVisuals)}> */}
                              <Button variant="contained" onClick={handleNext} disabled={(activeStep === 2 )}>
                                Next
                              </Button>
                            </Stack>
                          )}

                          {((userDetails.role == "admin" && (userDetails?.jobTitle == "admin" || userDetails?.jobTitle.toLowerCase() == "actor")) ||
                            userDetails.role == "subscriber") && (
                            <>
                              {project?.approvals &&
                              project.approvals?.scriptsAndVisuals ? (
                                <Button
                                  variant="contained"
                                  // onClick={() => {
                                  //   handleApprove("scriptsAndVisuals");
                                  // }}
                                  disabled={project.approvals.scriptsAndVisuals}
                                >
                                  Approved
                                </Button>
                              ) : (
                                <>
                                  {
                                    originalProject && originalProject.topics && forOneTimeRender &&
                                      <div
                                        style={{
                                          position: "absolute",
                                          left: "-9999px",
                                          top: 0,
                                          width: '100%'
                                        }}
                                      >
                                        <div ref={pdfRef}>
                                          <ScriptPdf project={originalProject} />
                                        </div>
                                      </div>
                                  }
                                  <Button
                                    variant="contained"
                                    onClick={() => {
                                      // handleApprove("scriptsAndVisuals");
                                      // generateAndUploadPDF();
                                      if(isChangedScript){
                                        setConfirmModalScript(true);
                                      } else {
                                        handleApproveModal("scriptsAndVisuals");
                                      }
                                    }}
                                    disabled={isStageApproving || !originalProject.isScriptUpdated}
                                  >
                                    {/* {isScriptApproving? <>
                                        <CircularProgress size={20} style={{ marginRight: 8 }} />
                                        Approving...
                                      </>
                                    : 'Approve Script'} */}
                                    Approve Script
                                  </Button>
                                </>
                              )}
                            </>
                          )}
                        </Stack>
                        :
                        <Stack
                          direction="row"
                          justifyContent={
                            // userDetails.role == "admin" ? "space-between" : "end"
                            'end'
                          }
                          gap={2}
                          sx={{ paddingLeft: "15px" }}
                        >
                          {/* {userDetails.role == "admin" && (
                            <Stack direction="row" gap={"10px"}>
                              <Button
                                variant="contained"
                                onClick={handleBack}
                                disabled={activeStep === 0}
                              >
                                Back
                              </Button>
                              <Button variant="contained" onClick={handleNext}>
                                Next
                              </Button>
                            </Stack>
                          )}
                          {userDetails?.role.toLowerCase() == "subscriber" && (
                            <Stack direction="row" gap={"10px"}>
                              <Button
                                variant="contained"
                                onClick={handleBack}
                                disabled={activeStep === 0}
                              >
                                Back
                              </Button>
                              <Button variant="contained" onClick={handleNext} disabled={(activeStep === 2 )}>
                                Next
                              </Button>
                            </Stack>
                          )} */}

                          {((userDetails.role == "admin" && (userDetails?.jobTitle == "admin" || userDetails?.jobTitle.toLowerCase() == "actor")) ||
                            userDetails.role == "subscriber") && (
                            <>
                              {project?.approvals &&
                              project.approvals?.scriptsAndVisuals ? (
                                <Button
                                  variant="contained"
                                  // onClick={() => {
                                  //   handleApprove("scriptsAndVisuals");
                                  // }}
                                  disabled={project.approvals.scriptsAndVisuals}
                                >
                                  Video Generated
                                </Button>
                              ) : (
                                <>
                                  <Button
                                    variant="contained"
                                    onClick={handleGenerateInitiate}
                                    disabled={isStageApproving || !originalProject.isScriptUpdated || isGenerating}
                                  >
                                    {isGenerating ? (
                                      <>
                                        <CircularProgress size={18} style={{ marginRight: 8, color: '#fff' }} />
                                        Generating...
                                      </>
                                    ) : (
                                      'Generate Videos'
                                    )}
                                  </Button>
                                </>
                              )}
                            </>
                          )}
                        </Stack>
                      }
                    </Box>
                  </Box>
                )}

                {/* step 2 bottom buttons */}
                {activeStep === 1 && !isFullAutomated && (
                  <BottomButtons 
                    userDetails={userDetails}
                    handleNext={handleNext}
                    handleBack={handleBack}
                    activeStep={activeStep}
                    project={project}
                    isStageApproved={project?.approvals?.voiceOver}
                    handleApproveModal={handleApproveModal}
                    stepName="voiceOver"
                    buttonName= "Approve Voice Over"
                    isFullAutomated={isFullAutomated}
                  />
                )}

                {/* step 3 bottom buttons */}
                {activeStep === 2 && (
                  <BottomButtons 
                    userDetails={userDetails}
                    handleNext={handleNext}
                    handleBack={handleBack}
                    activeStep={activeStep}
                    project={project}
                    isStageApproved={project?.approvals?.video}
                    handleApproveModal={handleApproveModal}
                    stepName="video"
                    buttonName= "Approve Video"
                    isFullAutomated={isFullAutomated}
                  />
                )}
              </Box>
            </Grid2>
            
            {/* Approve Stage Modal */}
            <ApproveStageModal
              open={isModalOpen}
              onClose={() => setModalOpen(false)}
              onApprove={handleApprove}
              approveScript={generateAndUploadPDF}
              stage={approveStageName}
              loading={isStageApproving}
            />

            {/* Right Side: Chat Box (25%) */}
            {associatedUser.length > 0 && (
              <Grid2 size={{ xs: 12, md: 4 }}>
                <ProjectChat
                  project={originalProject}
                  userDetails={userDetails}
                  associatedUser={associatedUser}
                />
              </Grid2>
            )}

          </Grid2>
          
          {/* Newsletter Script Modal */}
          <NewsletterScriptModal
            open={scriptGenerateModalOpen}
            onClose={() => setScriptGenerateModalOpen(false)}
            userDetails={userDetails}
            handleAddScriptInPageInput={updateProjectTopicsFromAi}
          />

          {/* Avatar Selection Modal */}
          <AvatarSelectionModal
            open={avatarModalOpen}
            onClose={() => setAvatarModalOpen(false)}
            onSelectAvatar={(avatar) => {
              const avatarId = avatar.avatar_id || avatar.id || avatar._id || avatar.character_id;
              setProject(prev => ({ ...prev, avatar_id: avatarId }));
              console.log('Selected avatar in project board:', avatar);
              setProjectAvatar(avatar);
            }}
            projectId={project?._id}
            userDetails={userDetails}
            showMessage={showMessage}
            project={project}
          />
        </Box>
      )}
    </>
  );
};


function BottomButtons({userDetails, handleNext, handleBack, activeStep, project, isStageApproved, handleApproveModal, stepName, buttonName, isFullAutomated}) {
  return (
    <Box sx={{ flexShrink: 0, paddingY: 2, paddingRight: 2 }}>
      <Stack
        direction="row"
        justifyContent={isFullAutomated ? 'flex-end' : 'space-between'}
        gap={2}
      >
        {userDetails.role == "admin" && !isFullAutomated && (
          <Stack direction="row" gap={"10px"}>
            <Button
              variant="contained"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              Back
            </Button>
            <Button variant="contained" onClick={handleNext} disabled={activeStep === 2}>
              Next
            </Button>
          </Stack>
        )}

        {userDetails?.role.toLowerCase() == "subscriber" && !isFullAutomated && (
          <Stack direction="row" gap={"10px"}>
            <Button
              variant="contained"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              Back
            </Button>
            {/* <Button variant="contained" onClick={handleNext} disabled={(activeStep === 2 || !isStageApproved)}> */}
            <Button variant="contained" onClick={handleNext} disabled={(activeStep === 2 )}>
              Next
            </Button>
          </Stack>
        )}

        {((userDetails.role == "admin" &&
          (userDetails.jobTitle == "admin" || userDetails?.jobTitle.toLowerCase() == "actor")) ||
          userDetails.role == "subscriber") && (
          <>
            {isStageApproved ? (
              <Button
                variant="contained"
                disabled={isStageApproved}
              >
                Approved
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  handleApproveModal(stepName);
                }}
              >
                {buttonName}
              </Button>
            )}
          </>
        )}
      </Stack>
    </Box>
  );
}

export default ProjectBoard;

